export const environment = {
  production: false,
  hmr: true,
  productionDomain: "https://miracleih.com.sa/public",
  developmentDomain: "https://miracleih.com.sa/public",
};
